import { createAction, props } from '@ngrx/store';
import { SupplierInvoiceModel } from '@shared/data-access/models';

export const loadItem = createAction('[SUPPLIER INVOICE] LOAD ITEM', props<{ id: number }>());
export const loadItemSuccess = createAction('[SUPPLIER INVOICE] LOAD ITEM SUCCESS', props<{ item: SupplierInvoiceModel }>());
